import PropTypes from 'prop-types'

import MoleculeAvatar, {moleculeAvatarSizes} from '@s-ui/react-molecule-avatar'
import MoleculeRating from '@s-ui/react-molecule-rating'
import IconStarFull from '@adv-mt/mt-svg-icons/lib/StarFull'
import IconStarHalf from '@adv-mt/mt-svg-icons/lib/StarHalf'
import IconStarEmpty from '@adv-mt/mt-svg-icons/lib/StartEmpty'

const CardRatingHeaderLeft = ({rating, reviewerName, showAvatar, showRating}) => {
  return (
    <div className="mt-CardRating-headerLeft">
      {showRating && (
        <MoleculeRating
          IconStarEmpty={IconStarEmpty}
          IconStarFilled={IconStarFull}
          IconStarHalfFilled={IconStarHalf}
          value={rating}
        />
      )}
      {showAvatar && <MoleculeAvatar size={moleculeAvatarSizes.SMALL} />}
      <p className="mt-CardRating-headerLabel">{reviewerName}</p>
    </div>
  )
}

CardRatingHeaderLeft.displayName = 'CardRatingHeaderLeft'

CardRatingHeaderLeft.propTypes = {
  rating: PropTypes.number.isRequired,
  reviewerName: PropTypes.string.isRequired,
  showAvatar: PropTypes.bool,
  showRating: PropTypes.bool
}

export default CardRatingHeaderLeft
